'use client';

import { SimpleBlock, Text } from '@soluto-private/mx-asurion-ui-react';
import clsx from 'clsx';

type CallToActionProps = {
  heading?: string | null;
  body?: string | null;
  className?: string;
  image?: React.ReactNode;
  imageAlignment?: string | null;
  link?: React.ReactNode;
  backgroundColor?: string | null;
  textColor?: string | null;
};

export function CallToAction({
  backgroundColor,
  body,
  className,
  heading,
  image,
  imageAlignment,
  link,
  textColor,
}: CallToActionProps) {
  if (!heading && !body && !image && !link) {
    return null;
  }

  return (
    <SimpleBlock
      className={clsx(
        'flex rounded-lg max-md:border max-md:border-solid max-md:border-[#C6C6CA] md:my-8 [&>div]:flex-col [&>div]:gap-4 [&>div]:md:max-h-72',
        className,
        {
          '[&>div]:md:flex-row': !imageAlignment || imageAlignment === 'left',
          '[&>div]:md:flex-row-reverse': imageAlignment === 'right',
        },
      )}
      style={{ background: backgroundColor ?? 'white' }}
    >
      {image && <div className="relative items-start self-center">{image}</div>}
      <div className="flex flex-col gap-4 self-center rounded-b-lg p-4 text-left max-md:bg-white md:items-start md:bg-transparent [&>a]:max-md:!border-[#8223D2] [&>a]:max-md:!bg-[#8223D2] [&>a]:max-md:!text-white">
        <Heading textColor={textColor ?? undefined}>{heading}</Heading>
        <Body textColor={textColor ?? undefined}>{body}</Body>
        {link}
      </div>
    </SimpleBlock>
  );
}

function Heading({
  children,
  textColor,
}: React.PropsWithChildren & { textColor?: string }) {
  if (!children) {
    return null;
  }

  return (
    <h2
      className={clsx('font-normal', {
        [`max-md:!text-black !text-${textColor}`]: !!textColor,
      })}
    >
      {children}
    </h2>
  );
}

function Body({
  children,
  textColor,
}: React.PropsWithChildren & { textColor?: string }) {
  if (!children) {
    return null;
  }

  return (
    <Text
      as="p"
      className={clsx({
        [`max-md:!text-[#5D5E61] !text-${textColor}`]: !!textColor,
      })}
    >
      {children}
    </Text>
  );
}
